module.exports = __webpack_public_path__ + "img/wa.3a8dad7f.png";